module.exports = require("@swa-ui/dotcom/src/DotcomHeader/DotcomHeader.module.scss");